export default "__VITE_ASSET__DoHIA8zP__"